export const getSimChannelFromURL = () => {
	if (
		typeof window !== "undefined" &&
		window.location.search.includes("simChannel=")
	) {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const simChannel = urlParams.get("simChannel");
		return simChannel || undefined;
	}

	return undefined;
};
